import React from "react";
import { Box, Button, makeStyles, Theme } from "@material-ui/core";

import IButtonSettings from "./types/IButtonSettings";

interface CalloutButtonProps {
  buttonSettings: IButtonSettings;
  lastCallout: string;
  calloutType: number;
  createCallout: any;
  loading: boolean;
}

const useStyles = makeStyles<Theme, IButtonSettings>((theme) => ({
  root: {
    fontFamily: "Lato",
    width: "100%",
    height: "100%",
  },
  button: {
    width: "300px",
    height: "300px",
    textAlign: "center",
    backgroundColor: (props) => props.color,
    borderRadius: "27px",
    boxShadow: "0px 2px 40px rgba(0, 0, 0, 0.13)",
    "& .content": {
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      gap: "30px",
      alignItems: "center",
      justifyContent: "center",
      "& .iconSec": {
        "& img": {
          height: "100px",
        },
      },
      "& .titleSec": {
        color: "#00152E",
        fontSize: "30px",
        fontWeight: 900,
        fontStyle: "Black",
        textAlign: "center",
      },
    },
  },
  lastCalloutInfo: {
    fontSize: "15px",
    fontWeight: 400,
    marginTop: "20px",
  },
}));

const CalloutButton: React.FC<CalloutButtonProps> = ({ buttonSettings, lastCallout, calloutType, createCallout, loading }) => {
  const classes = useStyles(buttonSettings);

  return (
    <Box className={classes.root}>
      <Button className={classes.button} disabled={loading} onClick={() => createCallout(calloutType)}>
        <div className="content">
          <div className="iconSec">
            <img src={buttonSettings.icon} alt="" />
          </div>
          <div className="titleSec">
            <div>{buttonSettings.firstLabel}</div>
            <div>{buttonSettings.secondLabel}</div>
          </div>
        </div>
      </Button>
      {lastCallout && (
        <div className={classes.lastCalloutInfo}>
          {`Last callout ${lastCallout} ago`}
        </div>
      )}
    </Box>
  );
};

export default CalloutButton;
